import React, { Component } from 'react';
import styled from 'styled-components';
import safari from './safari.jpg'

const Container = styled.div`
  position: fixed;
  background-color: #fff;
  width: 100%;
  bottom: 0;
  text-align: center;
  display: flex;
  flex-direction: row;
  z-index:20;

`;

const TextHeader = styled.div`
  position: absolute;
  height: 44px;
  background: #DD3F00;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

const AppWrapper = styled.div`
  margin-top: 44px;
  color: black;
  display: flex;
  flex-direction: column;
  width: 70%;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
`;

const AppContainer = styled.div`
  color: black;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  align-items: center;
`;

const App = styled.div`
  display: flex;
  flex-direction: row;
  height: 80px;
  align-items: center;
`

const AppIcon = styled.img`
  height: 60px;
  width: 60px;
  border-radius: 12px;
`;

const AppName = styled.div`
  margin: 10px;
`;

const AppButton = styled.button`
width: 76px;
height: 44px;
color: white;
background: #DD3F00;
border-radius: 4px;
`;

const compAppSetting = 'https://apps.apple.com/us/app/coupa-cafe-app/id1199495613';
const companyAppId = compAppSetting.substring(compAppSetting.lastIndexOf('/') + 3);
const itunesLookupBase = 'http://itunes.apple.com/lookup?id='
const lookupUrl = itunesLookupBase + companyAppId;
class index extends Component {

  state = {
    isLoaded: false,
    appleIcon: null,
    showModal: true,
  };

  componentDidMount() {
    console.log(lookupUrl)
    fetch(lookupUrl)
      .then(res => res.json())
      .then(
        (result) => {
          console.log(result)
          this.setState({
            isLoaded: true,
            appleIcon: result.results[0].artworkUrl60
          });
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          this.setState({
            isLoaded: true,
            appleIcon: null
          });
        }
      )
  }

  openApp = () => {
    console.log('openApp...')
    this.setState({ showModal: false })
  }
  continueInBrowser = () => {
    console.log('continueInBrowser')
    this.setState({ showModal: false })
  }

  render() {

    if (!this.state.isLoaded) {
      return <div>Loading...</div>
    }

    return (
      this.state.showModal &&
      <Container>
        <TextHeader>
          Continue your order in...
        </TextHeader>
        <AppContainer>
          <AppWrapper>
            <App>
              <AppIcon src={this.state.appleIcon} />
              <AppName>The Foundry</AppName>
            </App>
            <a href={this.props.deeplinkToApp}>
              <AppButton >Open</AppButton>
            </a>
          </AppWrapper>
          <AppWrapper>

            <App>
              <AppIcon src={safari} />
              <AppName>Safari</AppName>
            </App>
            <AppButton onClick={this.continueInBrowser}>Continue</AppButton>
          </AppWrapper>
        </AppContainer>
      </Container >
    );
  }
};

const x =
{
  "resultCount": 1,
  "results": [
    {
      "screenshotUrls": ["https://is2-ssl.mzstatic.com/image/thumb/Purple113/v4/06/75/19/067519ac-96d9-5ffe-5825-a38336a9f811/mzl.vhkqzfmb.png/392x696bb.png", "https://is1-ssl.mzstatic.com/image/thumb/Purple123/v4/07/fa/87/07fa8725-d3fc-1022-9560-f97420fd36ce/mzl.cbzocvcg.png/392x696bb.png", "https://is5-ssl.mzstatic.com/image/thumb/Purple123/v4/c1/c8/d7/c1c8d7c0-f3fd-350f-f1d6-2cc0e61abdbd/mzl.mfaaozmp.png/392x696bb.png", "https://is4-ssl.mzstatic.com/image/thumb/Purple123/v4/64/be/5e/64be5ed4-6308-6c8c-a05e-11c7daf2d70e/mzl.eelwlzau.png/392x696bb.png", "https://is1-ssl.mzstatic.com/image/thumb/Purple123/v4/22/fd/52/22fd5287-c08d-ed36-c976-59bcf6d8eace/mzl.rlbrwfnw.png/392x696bb.png"], "ipadScreenshotUrls": [], "appletvScreenshotUrls": [], "artworkUrl60": "https://is2-ssl.mzstatic.com/image/thumb/Purple113/v4/a3/d6/09/a3d609fe-b874-9ae5-df25-3ca863e39dea/source/60x60bb.jpg", "artworkUrl512": "https://is2-ssl.mzstatic.com/image/thumb/Purple113/v4/a3/d6/09/a3d609fe-b874-9ae5-df25-3ca863e39dea/source/512x512bb.jpg", "artworkUrl100": "https://is2-ssl.mzstatic.com/image/thumb/Purple113/v4/a3/d6/09/a3d609fe-b874-9ae5-df25-3ca863e39dea/source/100x100bb.jpg", "artistViewUrl": "https://apps.apple.com/us/developer/coupa-cafe/id409242720?uo=4", "isGameCenterEnabled": false,
      "supportedDevices": ["iPhoneSE-iPhoneSE", "iPadProFourthGen-iPadProFourthGen", "iPodTouchSixthGen-iPodTouchSixthGen", "iPhoneX-iPhoneX", "iPodTouchSeventhGen-iPodTouchSeventhGen", "iPadAir3Cellular-iPadAir3Cellular", "iPhone6Plus-iPhone6Plus", "iPadPro-iPadPro", "iPhone11-iPhone11", "iPhone6-iPhone6", "iPad611-iPad611", "iPhone6sPlus-iPhone6sPlus", "iPadProSecondGen-iPadProSecondGen", "iPhone8Plus-iPhone8Plus", "iPadMiniRetina-iPadMiniRetina", "iPadAir3-iPadAir3", "iPad612-iPad612", "iPad812-iPad812", "iPad74-iPad74", "iPhone8-iPhone8", "iPhone11ProMax-iPhone11ProMax", "iPadMini5Cellular-iPadMini5Cellular", "iPadProFourthGenCellular-iPadProFourthGenCellular", "iPhone7-iPhone7", "iPadPro97Cellular-iPadPro97Cellular", "iPadMini5-iPadMini5", "iPad856-iPad856", "iPad76-iPad76", "iPadAir2-iPadAir2", "iPad75-iPad75", "iPhone5s-iPhone5s", "iPadMini3-iPadMini3", "iPadMini3Cellular-iPadMini3Cellular", "iPadAir-iPadAir", "iPadMini4-iPadMini4", "iPadProCellular-iPadProCellular", "iPhoneXS-iPhoneXS", "iPadMini4Cellular-iPadMini4Cellular", "iPadAirCellular-iPadAirCellular", "iPadPro97-iPadPro97", "iPhoneSESecondGen-iPhoneSESecondGen", "iPhone7Plus-iPhone7Plus", "iPadMiniRetinaCellular-iPadMiniRetinaCellular", "iPhoneXSMax-iPhoneXSMax", "iPhone6s-iPhone6s", "iPad71-iPad71", "iPad73-iPad73", "iPadSeventhGen-iPadSeventhGen", "iPadAir2Cellular-iPadAir2Cellular", "iPad72-iPad72", "iPhone11Pro-iPhone11Pro", "iPadProSecondGenCellular-iPadProSecondGenCellular", "iPadSeventhGenCellular-iPadSeventhGenCellular", "iPad834-iPad834", "iPad878-iPad878", "iPhoneXR-iPhoneXR"], "advisories": [], "features": [], "kind": "software", "trackCensoredName": "Coupa Cafe", "languageCodesISO2A": ["EN"], "fileSizeBytes": "67995648", "sellerUrl": "https://www.coupacafe.com", "contentAdvisoryRating": "4+", "averageUserRatingForCurrentVersion": 4.78437000000000001165290086646564304828643798828125, "userRatingCountForCurrentVersion": 589, "averageUserRating": 4.78437000000000001165290086646564304828643798828125, "trackViewUrl": "https://apps.apple.com/us/app/coupa-cafe/id1199495613?uo=4", "trackContentRating": "4+", "currentVersionReleaseDate": "2020-04-14T15:39:43Z",
      "releaseNotes": "- Now supporting Apple Sign In for new accounts.\n- Smarter Delivery experience by choosing nearest open location automatically.\n- Curbside Improvements.\n- Performance improvements and bug-squashing.\n- Please continue to leave valuable feedback, so we can continue to keep enhancing your app experience!", "trackId": 1199495613, "trackName": "Coupa Cafe", "releaseDate": "2017-05-16T16:41:16Z", "genreIds": ["6023", "6016"], "formattedPrice": "Free", "primaryGenreName": "Food & Drink", "isVppDeviceBasedLicensingEnabled": true, "minimumOsVersion": "11.0", "primaryGenreId": 6023, "sellerName": "Coupa Cafe", "currency": "USD",
      "description": "The Coupa app is the fastest way to order, pay, earn rewards & reload your Coupa Card.\n\n - Collect points for every dollar you spend & earn rewards!\n - Mobile Order & Pay: Skip the line by customizing & placing your order. \n - Pay: Use your phone to pay at any Coupa Café location.\n - Coupa Card: earn loyalty rewards, reload, view & protect your balance.\n - Store Locator: find the nearest location, directions & hours.", "artistId": 409242720, "artistName": "Coupa Cafe", "genres": ["Food & Drink", "Entertainment"], "price": 0.00, "bundleId": "com.ncr.release.Coupa-Cafe", "version": "20.2.0", "wrapperType": "software", "userRatingCount": 589
    }]
}







export default index;
